export default function sessionToken(state) {
  return state.session && state.session.token;
}
